export const environment = {
  apiUrl: 'http://192.168.2.205:8000',
  wsUrl: 'ws://192.168.2.205:8080',
};
